import { CATEGORIES, CATEGORY_LABELS } from "@/constants/categories";

// CategoryFocusModal - Auswahl der Kategorie für fokussierte Taten
const CategoryFocusModal = ({ 
  show,
  focusCategory,
  language,
  t,
  onSelectCategory,
  onClose 
}) => {
  if (!show) return null;
  
  return (
    <div className="notification-prompt-overlay" data-testid="category-setup-overlay">
      <div className="notification-prompt category-setup-modal">
        <div className="category-setup-header">
          <h3>{t.categoryFocusTitle || "Dein Schwerpunkt"}</h3>
          <p className="category-setup-subtext">
            {t.categoryFocusSubtext || "Wähle eine Kategorie für fokussierte Taten"}
          </p>
        </div>
        
        <div className="category-setup-grid">
          <button 
            className={`category-setup-btn ${!focusCategory ? 'selected' : ''}`}
            onClick={() => onSelectCategory(null)}
          >
            <span className="category-setup-icon">✨</span>
            <span className="category-setup-label">{t.categoryAll || "Alle Kategorien"}</span>
            {!focusCategory && (
              <span className="category-active-badge">
                {t.categoryFocusActive || "Aktiv"}
              </span>
            )}
          </button>
          
          {Object.entries(CATEGORIES).map(([key, config]) => {
            const Icon = config.icon;
            return (
              <button 
                key={key}
                className={`category-setup-btn ${focusCategory === key ? 'selected' : ''}`}
                onClick={() => onSelectCategory(key)}
                style={{ '--cat-color': config.color }}
              >
                <span className="category-setup-icon"><Icon size={20} /></span>
                <span className="category-setup-label">
                  {CATEGORY_LABELS[key]?.[language] || key}
                </span>
                {focusCategory === key && (
                  <span className="category-active-badge">
                    {t.categoryFocusActive || "Aktiv"}
                  </span>
                )}
              </button>
            );
          })}
        </div>
        
        <button className="prompt-btn tertiary" onClick={onClose}>
          {t.postDeedDone || "Fertig"}
        </button>
      </div>
    </div>
  );
};

export default CategoryFocusModal;
